module.exports = __webpack_public_path__ + "static/media/logo-nayra-fundo-preto.4acc54d7.svg";